<template>
	<vs-avatar size="50" :badge="badge" badge-color="success" circle>
		<img
			v-if="img"
			src="https://randomuser.me/api/portraits/men/82.jpg"
			:alt="text || 'User'"
		/>
		<template #text v-if="!img">
			{{ text || "User" }}
		</template>
	</vs-avatar>
</template>

<script>
//class="mr-3"
export default {
	props: {
		img: String,
		badge: Boolean,
		text: String
	}
}
</script>
